import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_contracts_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId?: number, projectId?: number, statusIds?: number[], accountId?: number, fullTextSearch?: string, endDate?: string }): 
  Promise<{ result: { Id?: number, AutoRenewalPercentage?: number, EndDate?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Notes?: string, StartDate?: string, StatusId?: number, Status?: { Name?: string }, Project?: { Name?: string, Owner?: { Name?: string } }, AutoRenewalType?: { Name?: string }, Account?: { Name?: string }, TaxSchedule?: { Label?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contracts_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId?: number, projectId?: number, statusIds?: number[], accountId?: number, fullTextSearch?: string, endDate?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AutoRenewalPercentage?: number, EndDate?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Notes?: string, StartDate?: string, StatusId?: number, Status?: { Name?: string }, Project?: { Name?: string, Owner?: { Name?: string } }, AutoRenewalType?: { Name?: string }, Account?: { Name?: string }, TaxSchedule?: { Label?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contracts_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId?: number, projectId?: number, statusIds?: number[], accountId?: number, fullTextSearch?: string, endDate?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, AutoRenewalPercentage?: number, EndDate?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Notes?: string, StartDate?: string, StatusId?: number, Status?: { Name?: string }, Project?: { Name?: string, Owner?: { Name?: string } }, AutoRenewalType?: { Name?: string }, Account?: { Name?: string }, TaxSchedule?: { Label?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contracts_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId?: number, projectId?: number, statusIds?: number[], accountId?: number, fullTextSearch?: string, endDate?: string    }) {
      return false;
    }
}
